import { Camera } from '@hakimo-ui/hakimo/types';
import { SpeakerWaveIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

interface Props {
  camera: Camera;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export function CameraItem(props: Props) {
  const { camera, selected, onClick, disabled } = props;
  const hasAudioDevices = camera.audioDevices && camera.audioDevices.length > 0;

  return (
    <button
      onClick={onClick}
      className={clsx(
        'flex w-full cursor-pointer items-center gap-4 rounded-md px-4 py-3 outline-none',
        selected
          ? 'bg-onlight-bg-3 dark:bg-ondark-bg-3'
          : 'hover:bg-onlight-bg-3/50 dark:hover:bg-ondark-bg-3/50',
        disabled &&
          'bg-onlight-bg-3/70 dark:bg-ondark-bg-3/70 pointer-events-none disabled:opacity-75'
      )}
    >
      {/* Left: Camera icon and optional speaker icon */}
      <div className="flex flex-col items-center gap-1">
        <VideoCameraIcon
          className="text-onlight-text-2 dark:text-ondark-text-2 h-5 w-5"
          aria-hidden="true"
        />
        {hasAudioDevices && (
          <SpeakerWaveIcon
            className="text-onlight-text-2 dark:text-ondark-text-2 h-4 w-4"
            aria-hidden="true"
          />
        )}
      </div>

      {/* Middle: Camera details */}
      <div className="flex min-w-0 flex-1 flex-col items-start gap-0.5">
        <span className="w-full truncate text-start" title={camera.name}>
          {camera.name}
        </span>
        <span className="text-onlight-text-2 dark:text-ondark-text-2 w-full truncate text-start text-sm">
          {camera.location?.name || '-'}
        </span>
        <div className="flex w-full items-center justify-between text-xs font-medium">
          <span
            className="text-onlight-text-3 dark:text-ondark-text-2"
            title={`Integration type - ${camera.integrationType}`}
          >
            {camera.integrationType}
          </span>
          <span
            className={clsx(
              camera.armStatus.isArmed
                ? 'text-status-orange'
                : 'text-status-green'
            )}
          >
            {camera.armStatus.isArmed ? 'Armed' : 'Disarmed'}
          </span>
        </div>
      </div>
    </button>
  );
}

export default CameraItem;
